/*  
  Developers: Sakshi Bhise  
  File: i18n.tsx  
  Date: 06/18/2025  
  Project Name: AskHR  
  Team: DSET  
  
  Purpose:  
  Configures internationalization (i18n) for the AskHR application using i18next and react-i18next.  
  Loads translations for supported languages, detects user language preferences, and integrates  
  locale switching for multilingual user experiences across the portal.  
*/ 

// Import necessary modules  
import i18next from "i18next";  
import { initReactI18next } from "react-i18next";  
import LanguageDetector from "i18next-browser-languagedetector"; // Import the language detector for detecting the language from browser language 
import HttpBackend from "i18next-http-backend";  
  

const backend_url = import.meta.env.VITE_BACKEND_URL || ""

// Initialize i18next  
i18next  
  .use(HttpBackend)
  // .use(LanguageDetector) // Use the browser language detector  
  .use(initReactI18next) // Pass i18next to react-i18next  
  .init({  
    //resources,  
    fallbackLng: "en", // Fallback language if detection fails  
    //debug: true, // Enable debug mode for development  
    interpolation: {  
      escapeValue: false, // React already escapes values  
    },  
    detection: {  
      order: ["navigator", "htmlTag", "querystring", "cookie", "localStorage"], // Detection order  
      caches: ["cookie", "localStorage"], // Cache the detected language  
    }, 
    backend: {  
      loadPath: `${backend_url}/api/translations/{{lng}}.json`, // i18next will do the fetch automatically  
    }, 
  });  
  
export default i18next;  